import React, { useState } from 'react';

import { Typography } from 'antd';
import styled from 'styled-components';

import Button from 'components/lib/Button';

import NoteModal from '../NoteModal/NoteModal';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`;
const Title = styled(Typography.Text)`
  font-family: var(--font-bold);
`;

const EditButton = styled(Button)`
  color: var(--dark-blue);
  cursor: pointer;
  margin-left: 2px;
  padding: 0;
  box-shadow: none;
`;

const Note = styled(Typography.Text)`
  display: block;
  font-size: 12px;
  color: var(--text-secondary);
  width: 100%;
  padding-left: 32px;
  word-break: break-word;
  white-space: pre-wrap;
`;

type Props = {
  note?: string | null;
  title: string;
  allowEdit: boolean;
  disabled?: boolean;
  hideTitle?: boolean;
  updateNote: (note: string) => void;
};

const EditShopRequestModalNote = ({
  note,
  title,
  allowEdit,
  disabled = false,
  hideTitle = false,
  updateNote,
}: Props) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const openNoteEditing = () => setModalOpen(true);

  return (
    <>
      {(!hideTitle || allowEdit) && (
        <Container>
          {!hideTitle && <Title>{title}</Title>}
          {allowEdit && (
            <>
              {!hideTitle && <span>·</span>}
              <EditButton size="small" type="link" disabled={disabled} onClick={openNoteEditing}>
                Edit
              </EditButton>
            </>
          )}
        </Container>
      )}
      <Note>{note}</Note>
      {isModalOpen && (
        <NoteModal
          title="Edit Note"
          note={note}
          isModalOpen={isModalOpen}
          closeModal={() => setModalOpen(false)}
          modifyNote={updateNote}
        />
      )}
    </>
  );
};

export default EditShopRequestModalNote;
